import React from 'react';
import { useMultiFactorId } from '../../hooks/Auth';
import { Route, RouteProps } from 'react-router-dom';
import EnrollMultiFactorFlow from './account-security/VerifyMultiFactorFlow';
import { CONTENT_PAGE_WIDTH } from '../../constants/ForestConstant';
import { Card } from 'antd';
import { useCurrentUser } from '../../redux/selector';

const DANGEROUS_ALLOW_LIST = ['board_demo@tryforest.com', 'owner_demo@tryforest.com', 'test-user@foresthoa.io'];

const SensitiveRoute: React.FC<React.PropsWithChildren<RouteProps>> = ({ children, ...rest }) => {
  const multiFactorId = useMultiFactorId();

  const user = useCurrentUser();
  const bypassMultiFactor = user && DANGEROUS_ALLOW_LIST.find((email) => email === user.email);

  return (
    <Route
      {...rest}
      render={({ location }) => {
        if (multiFactorId || bypassMultiFactor) {
          return children;
        }
        return (
          <Card className="text-md-left mobile-full-width-content py-8" style={{ maxWidth: CONTENT_PAGE_WIDTH }}>
            <EnrollMultiFactorFlow onComplete={() => {}} />
          </Card>
        );
      }}
    />
  );
};

export default SensitiveRoute;
